import {setIsWeb} from './env';

setIsWeb(true);
